import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import useAuthentication from '../auth/authHelper'

const PublicRoutes = () => {
  const { isAuthenticated } = useAuthentication();
    if(isAuthenticated()) {
        return <Navigate to={'/start'} />
    }
  return <Outlet />
}

export default PublicRoutes